import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {InvestorAllocatedLoansComponent} from './investor-allocated-loans/investor-allocated-loans.component';

const routes: Routes = [{
    path: '',
    component: InvestorAllocatedLoansComponent
}];

@NgModule({
    exports: [RouterModule],
    imports: [RouterModule.forChild(routes)]
})
export class InvestorLoansRoutingModule {
}
